import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, ModalContent, Text } from '@percent/lemonade'
import { PercentButton, Dialog } from '@percent/admin-dashboard/common/components'
import { ReactComponent as RejectedIcon } from '@percent/admin-dashboard/common/assets/images/rejected.svg'
import styles from './BankDetailsDocument.module.scss'
import { BankDetailsDocumentErrorDialogProps } from '@percent/admin-dashboard/app/bankDetails/bankDetailsView/bankDetailsDocument/BankDetailsDocumentErrorDialog.types'

export function BankDetailsDocumentErrorDialog({ error }: BankDetailsDocumentErrorDialogProps) {
  const { t } = useTranslation()
  const [dialogState, setDialogState] = useState(error)

  const handleClose = () => {
    setDialogState(false)
  }

  return (
    <Dialog withoutHeader openModal={dialogState} onClose={handleClose}>
      <ModalContent>
        <Box className={styles.contentWrapper}>
          <RejectedIcon className={styles.icon} />
          <Text className={styles.titleText}>{t('errorMessage.errorHasOccurred')}</Text>
          <Text className={styles.descriptionText}>{t('dialog.bankDetails.documentError')}</Text>
          <div className={styles.singleButtonWrapper}>
            <PercentButton title={t('button.done')} onClick={handleClose} />
          </div>
        </Box>
      </ModalContent>
    </Dialog>
  )
}
